export const translations = {
  SEARCH_BUTTON: {
    da: 'Search',
    en: 'Search',
    fi: 'Search',
    no: 'Search',
    sv: 'Sök',
  },
  SEARCH_SUCCESS: {
    da: 'Your OCR number is',
    en: 'Your OCR number is',
    fi: 'Your OCR number is',
    no: 'Your OCR number is',
    sv: 'Ditt OCR-nummer är',
  },
  ERROR_INVALID_LICENSE_NUMBER: {
    da: 'Invalid license number',
    en: 'Invalid license number',
    fi: 'Invalid license number',
    no: 'Invalid license number',
    sv: 'Ogiltligt licensnummer',
  },
  ERROR_NO_RESULTS: {
    da: 'The search did not generate any results',
    en: 'The search did not generate any results',
    fi: 'The search did not generate any results',
    no: 'The search did not generate any results',
    sv: 'Sökningen genererade inga träffar',
  },
  ERROR_REASON_HEADER: {
    da: 'It may be due to:',
    en: 'It may be due to:',
    fi: 'It may be due to:',
    no: 'It may be due to:',
    sv: 'Det kan bero på:',
  },
  ERROR_REASON_ONE: {
    da: 'We could not find that license number',
    en: 'We could not find that license number',
    fi: 'We could not find that license number',
    no: 'We could not find that license number',
    sv: 'Vi hittar inget sådant licensnummer',
  },
  ERROR_REASON_TWO: {
    da: 'Check the information and try again.',
    en: 'Check the information and try again.',
    fi: 'Check the information and try again.',
    no: 'Check the information and try again.',
    sv: 'Kontrollera uppgifterna och försök igen.',
  },
  PLACEHOLDER_TEXT: {
    da: 'License number 6 digits',
    en: 'License number 6 digits',
    fi: 'License number 6 digits',
    no: 'License number 6 digits',
    sv: 'Licensnummer 6 tecken',
  },
};
